import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators, } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router, ActivatedRoute } from '@angular/router';
import { Console } from 'console';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from 'src/environments/environment';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';
import { ModalpopService } from '../modalpop.service';
import { UmsService } from '../ums.service';
import { PrintMsgBoxComponent } from '../print-msg-box/print-msg-box.component';
import { ExamFeeStudentsComponent } from '../exam-fee-students/exam-fee-students.component';

@Component({
  selector: 'app-exam-sc-edit',
  templateUrl: './exam-sc-edit.component.html',
  styleUrls: ['./exam-sc-edit.component.scss'],
})
export class ExamScEditComponent implements OnInit {
  submitButton = true;
  updateButton = false;
  showDiv = false;
  FeesNotPaid = false
  deleteReadOnly = false;
  Table = false;
  ExamSCEditForm: FormGroup;
  elgbRuleList;
  filteredElgbRuleList;
  filteredExamAList;
  submitpayload: any;
  dialogRef: MatDialogRef<any>;
  // empty after assignig to api start
  ExamAList;
  examRecords;
  // empty after assignig to api end
  statusList = [
    {
      name: 'Open',
      id: 'O',
    },
    {
      name: 'Close',
      id: 'C',
    },
  ];
  inputname
  filteredListOfEmEval: any;
  ExamInputList: any;
  filteredExamInputList: any;
  filteredstatusList: any;
  userList: any;
  filtereduserList: any;
  Glob_EcShId: any;
  APIService: string;
  userPermission: any;
  utp: any;
  ExCreate = true;
  ExUpdate = true;
  ExDelete = true;
  loginId = sessionStorage.getItem('userId');
  SessionNo: any;
  StuFee: any;
  EmId: any;
  CoCode: any;
  ADMRecords: any;
  Dates: any;
  incode: any;
  SHID: any;
  ShowExamTime: boolean;
  data: any;
  ShowRollNo: boolean;
  UpdateError: string;
  updateDisable = false;
  updateDisableMsg = false;
  SaveDisable = false;
  SaveError: string;
  UpdatedExams: any;
  ExamSrNo: any;
  EditListShow = false;
  updatereadonly=false;
  constructor(
    private modalPopupService: ModalpopService,
    public umsService: UmsService,
    private fb: FormBuilder,
    public router: Router,
    private dialog: MatDialog,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private httpClient: HttpClient,
  ) { this.APIService = environment.serviceUrl; }
  selectedRow: any | null = null;
  ngOnInit(): void {
    this.updateDisable = false;
    this.FeesNotPaid = false;
    this.updateDisableMsg = false;
    this.UpdateError = ''
    this.SaveDisable = false;
    this.SaveError = ''
    this.updatereadonly = false;
    if (JSON.parse(sessionStorage.getItem("session")) == null) {
      this.fetchSecretData();
    }
    else if (JSON.parse(sessionStorage.getItem("session")) != null) {
      let sessionData = JSON.parse(sessionStorage.getItem("session"));
      this.SessionNo = sessionData.SnNo;
      this.fetchSupExamRecord(this.SessionNo);
      this.getSchForUpdtReslist();
    }
    this.userPermission = JSON.parse(sessionStorage.getItem("userPermission"));
    this.utp = sessionStorage.getItem('usertypeee');
    if (this.utp !== 'Super Admin' && this.utp !== 'Admin') {
      // this.isSuperAdmin= false;
      this.userPermission.forEach(element => {
        if (element.PageName == 'Exam-Edit-Control' && element.PCreate == false) {
          this.ExCreate = false;
        }
        if (element.PageName == 'Exam-Edit-Control' && element.PUpdate == false) {
          this.ExUpdate = false;
        }
        if (element.PageName == 'Exam-Edit-Control' && element.PDelete == false) {
          this.ExDelete = false;
        }
      });
    }
    window.scroll(0, 0);
    this.getOpratorsList();
    this.Table = false;
    this.EditListShow = false;
    this.filteredstatusList = this.statusList.slice();
    // empty after assignig to api start
    this.ExamSCEditForm = this.fb.group({
      EcShId: new FormControl('', Validators.required),
      EcDesc: new FormControl('New'),
      EcInCode: new FormControl('', Validators.required),
      EcOpId: new FormControl('', Validators.required),
      EcOpenOpId: new FormControl(sessionStorage.getItem('userId')),
      EcStatus: new FormControl('O'),
      FrontEcInCode: new FormControl(''),
      FrontList: new FormControl(''),
      EcListNo: new FormControl(''),
      EcId: new FormControl(''),
    });
    // empty after assignig to api end
  }

  getSchForUpdtReslist() {
    let payload = {}
    payload['SnNo'] = this.SessionNo
    payload['LoginId'] = sessionStorage.getItem('userId');
    this.umsService.getSchForUpdtReslist(payload).subscribe((res) => {
      this.UpdatedExams = res.data;
    }
    );
  }

  fetchSecretData() {
    this.umsService.getSecretData().subscribe((res) => {
      this.SessionNo = res.projectPharam['SnNo']
      this.fetchSupExamRecord(this.SessionNo);
      this.getSchForUpdtReslist();
    }
    );
  }

  submit(){
    let sameShid = [];
    sameShid = this.UpdatedExams.filter(record => record.ShId == this.ExamSCEditForm.value['EcShId'])
    if(sameShid.length > 0){
      let data = {};
      data['message'] = 'This Exam Is Updated. Cannot Open New List';
      data['title'] = 'Alert';
      data['icon'] = 'fas fa-close';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent,data);
    }
    else{
      this.submitCheck();
    }

  }

  submitCheck() {
    if (this.ExamSCEditForm.value['EcInCode'] == 19) {
      let payload = {};
      this.ADMRecords = [];
      this.Dates = [];
      payload['SnNo'] = parseInt(this.SessionNo);
      payload['InCode'] = 'EMFRM'
      payload['CoCode'] = this.CoCode
      this.umsService.CheckValidDate(payload).subscribe(res => {
        if (res.status) {
          const examRecords = res.data.filter(record => record.EmId == this.EmId && record.CoCgCoCode == this.CoCode);
          const today = new Date();
          const todayDateString = today.toISOString().split('T')[0];
          if (examRecords.length > 0) {
            this.ADMRecords = res.data.filter(record => record.InCode === 'EMFRM');
          }
          let listCanOpen = false;
          for (let item of this.ADMRecords) {
            if (((item.FromDate.split('T')[0] === todayDateString && todayDateString < item.ToDate.split('T')[0])) || ((item.FromDate.split('T')[0] < todayDateString && todayDateString < item.ToDate.split('T')[0])) || ((item.FromDate.split('T')[0] < todayDateString && todayDateString == item.ToDate.split('T')[0]))) {
              listCanOpen = true;
              break;
            }
          }

          if (!listCanOpen) {
            if (this.ADMRecords.length == 0) {
              this.showAlert('First Enter CutOff Dates For This Exam');
            }
            else if (this.ADMRecords.length > 0) {
              for (let item of this.ADMRecords) {
                if (todayDateString > item.ToDate.split('T')[0]) {
                  this.showAlert('Exam Form Dates Are Closed For This Exam');
                  break;
                } else if (todayDateString < item.FromDate.split('T')[0]) {
                  this.showAlert('Exam Form Dates Are Still Not Open For This Exam');
                  break;
                }

              }
            }

          }
          if (listCanOpen == true && this.ExamSrNo == 1) {
            // this.submitFinal();
            this.checkRegister();
          }
          else
            if (listCanOpen == true && this.ExamSrNo > 1) {
              this.checksubselection();
            }
        } else {
          this.showAlert('First Enter CutOff Dates For This Exam');
        }
      });
    }
    else if (this.ExamSCEditForm.value['EcInCode'] == 7) {
      let payload = {};
      this.ADMRecords = [];
      this.Dates = [];
      payload['SnNo'] = parseInt(this.SessionNo);
      payload['InCode'] = 'MRKEN'
      payload['CoCode'] = this.CoCode
      this.umsService.CheckValidDate(payload).subscribe(res => {
        if (res.status) {
          const examRecords = res.data.filter(record => record.EmId === this.EmId);
          const today = new Date();
          const todayDateString = today.toISOString().split('T')[0];

          if (examRecords.length > 0) {
            this.ADMRecords = res.data.filter(record => record.InCode === 'MRKEN');
          }
          let listCanOpen = false;
          for (let item of this.ADMRecords) {
            if ((item.FromDate.split('T')[0] === todayDateString && todayDateString < item.ToDate.split('T')[0]) || (item.FromDate.split('T')[0] < todayDateString && todayDateString < item.ToDate.split('T')[0]) || (item.FromDate.split('T')[0] < todayDateString && todayDateString == item.ToDate.split('T')[0])) {
              listCanOpen = true;
              break;
            }
          }

          if (!listCanOpen) {
            if (this.ADMRecords.length == 0) {
              this.showAlert('First Enter CutOff Dates For This Exam');
            }
            else if (this.ADMRecords.length > 0) {
              for (let item of this.ADMRecords) {
                if (todayDateString > item.ToDate.split('T')[0]) {
                  this.showAlert('Marks Entry Dates Are Closed For This Exam');
                  break;
                } else if (todayDateString < item.FromDate.split('T')[0]) {
                  this.showAlert('Marks Entry Dates Are Still Not Open For This Exam');
                  break;
                }

              }
            }

          }
          if (listCanOpen == true) {
            this.checkCenterAllocation();
          }

        } else {
          this.showAlert('First Enter CutOff Dates For This Exam');
        }
      });
    }
    else if (this.ExamSCEditForm.value['EcInCode'] == 20) {
      if (this.ShowRollNo == true) {
        let data = {};
        data['message'] = 'First Generate Roll No';
        data['title'] = 'Alert';
        data['icon'] = 'fas fa-close';
        this.dialogRef =
          this.modalPopupService.openPopup<AlertBoxComponent>(
            AlertBoxComponent,
            data
          );
      }
      else if (this.ShowRollNo == false) {
       
        this.checkCenterAllocationForMarkEntry()
        // this.submitFinal()
      }
    }
    else if (this.ExamSCEditForm.value['EcInCode'] == 64) {

      let payload = {};
      this.ADMRecords = [];
      this.Dates = [];
      payload['SnNo'] = parseInt(this.SessionNo);
      payload['InCode'] = 'SubSe'
      payload['CoCode'] = this.CoCode
      this.umsService.CheckValidDate(payload).subscribe(res => {
        if (res.status) {
          const examRecords = res.data.filter(record => record.EmId == this.EmId && record.CoCgCoCode == this.CoCode);
          const today = new Date();
          const todayDateString = today.toISOString().split('T')[0];
          if (examRecords.length > 0) {
            this.ADMRecords = res.data.filter(record => record.InCode === 'SubSe');
          }
          let listCanOpen = false;
          for (let item of this.ADMRecords) {
            if (((item.FromDate.split('T')[0] === todayDateString && todayDateString < item.ToDate.split('T')[0])) || ((item.FromDate.split('T')[0] < todayDateString && todayDateString < item.ToDate.split('T')[0])) || ((item.FromDate.split('T')[0] < todayDateString && todayDateString == item.ToDate.split('T')[0]))) {
              listCanOpen = true;
              break;
            }
          }

          if (!listCanOpen) {
            if (this.ADMRecords.length == 0) {
              this.showAlert('First Enter CutOff Dates For Subject Selection');
            }
            else if (this.ADMRecords.length > 0) {
              for (let item of this.ADMRecords) {
                if (todayDateString > item.ToDate.split('T')[0]) {
                  this.showAlert(' Subject Selection Dates Are Closed For This Exam');
                  break;
                } else if (todayDateString < item.FromDate.split('T')[0]) {
                  this.showAlert(' Subject Selection Dates Are Still Not Open For This Exam');
                  break;
                }

              }
            }

          }
          if (listCanOpen == true) {
            this.submitFinal();
            // this.checkRegister();
          }
        } else {
          this.showAlert('First Enter CutOff Dates For  Subject Selection');
        }
      });
    }

    else {
      this.submitFinal();
    }

  }


  checksubselection() {
    this.spinner.show();
    let payload = {};
    payload['EcShId'] = this.ExamSCEditForm.value['EcShId'];
    payload['EcInCode'] = '';
    payload['EcOpId'] = sessionStorage.getItem('userId');
    this.umsService.getSupExamEditRecord(payload).subscribe(
      (res) => {
        this.spinner.hide();
        if (res.status) {
          this.Table = true
          this.examRecords = res.data;
          let allStatusU = true;
          this.examRecords.forEach(element => {
            if (element.EcInCode === 64 && element.EcStatus !== "U") {
              allStatusU = false;
          }
            // if (element.EcInCode = 64 && element.EcStatus == "O") {
            //   this.showAlert('Subject Selection List Not Updated');
            // }
            // else if (element.EcInCode = 64 && element.EcStatus == "U"){
            //   this.submitFinal()
            // }
          });
          if (allStatusU) {
            this.submitFinal();
        } else {
            this.showAlert('Subject Selection List Not Updated');
        }

        } 
        else {
          this.showAlert('Please open the list for subject selection.');
          
        }
      },
      (ERROR: HttpErrorResponse) => {
        this.Table = false;
        this.spinner.hide();
        this.examRecords = [];
      }
    );


  }

  checkRegister() {
    const payload = {};
    payload['CoCode'] = this.CoCode
    payload['CShStatus'] = '';
    payload['LoginId'] = sessionStorage.getItem('userId');
    payload['CShSnNo'] = parseInt(this.SessionNo);
    this.umsService.NewCoSch(payload).subscribe(res => {
      if (res.status) {
        this.check(res.data[0]['CShId'])
      }
      else{
        this.checkSession()
      }
    });
  }

  checkSession(){
    const payload = {};
    payload['SnNo'] = this.SessionNo;
    this.umsService.getSession(payload).subscribe(res => {
      if(res.status){
        if(res.data[0]['SnName'].includes('Re')){
          this.submitFinal();
        }
        else{
          let data = {}
          data['message'] = "Course Not Scheduled And Registration List Not Open"
          data['title'] = 'Information'
          data['icon'] = 'fas fa-check'
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
          this.SaveDisable = true;
        }
      }
    })
  }


  check(ShId) {
    const payload = {};
    payload['CEcInCode'] = 51;
    payload['CEcShId'] = ShId;
    payload['CEcOpId'] = sessionStorage.getItem('userId');
    this.umsService.getSupCourseEditRecord(payload).subscribe(res => {
      if (res.status) {
        if (res.data[0].CEcStatus == "U" || res.data[0].CEcStatus == "O") {
          // this.submitFinal();
          this.checkStudentStatus(ShId)
        } else {
          let data = {}
          data['message'] = "Registration List Not Updated"
          data['title'] = 'Information'
          data['icon'] = 'fas fa-check'
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
          this.SaveDisable = true;
          this.SaveError = data['message']
        }
      }
      else {
        let data = {}
        data['message'] = "Registration List Not Open"
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      }
    });
  }

  checkStudentStatus(ShId){
    const payload = {};
    payload['CEcInCode'] = 52;
    payload['CEcShId'] = ShId;
    payload['CEcOpId'] = sessionStorage.getItem('userId');
    this.umsService.getSupCourseEditRecord(payload).subscribe(res => {
      if (res.status) {
        if (res.data[0].CEcStatus == "U") {
          this.submitFinal();
        } else {
          let data = {}
          data['message'] = "Student Status List Not Updated"
          data['title'] = 'Information'
          data['icon'] = 'fas fa-check'
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
          this.SaveDisable = true;
          this.SaveError = data['message']
        }
      }
      else {
        this.submitFinal();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.submitFinal();
    });
  }



  checkCenterAllocation() {
    this.spinner.show();
    let payload = {};
    payload['EcShId'] = this.ExamSCEditForm.value['EcShId'];
    payload['EcInCode'] = 20;
    payload['EcOpId'] = sessionStorage.getItem('userId');
    this.umsService.getSupExamEditRecord(payload).subscribe(
      (res) => {
        this.spinner.hide();
        if (res.status) {
          this.Table = true
          this.examRecords = res.data;
          let allStatusU = true;
          this.examRecords.forEach(element => {
            if (element.EcInCode === 20 && element.EcStatus !== "U") {
              allStatusU = false;
          }
            // if (element.EcInCode = 64 && element.EcStatus == "O") {
            //   this.showAlert('Subject Selection List Not Updated');
            // }
            // else if (element.EcInCode = 64 && element.EcStatus == "U"){
            //   this.submitFinal()
            // }
          });
          if (allStatusU) {
            this.submitFinal();
        } else {
            this.showAlert('Center Allocation List Not Updated');
        }

        } 
        else {
          this.showAlert('Allocate Center');
          
        }
      },
      (ERROR: HttpErrorResponse) => {
        this.Table = false;
        this.spinner.hide();
        this.examRecords = [];
      }
    );


  }

  showAlert(message: string) {
    let data = {
      message: message,
      title: 'Alert',
      icon: 'fas fa-close'
    };
    this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
  }

  submitFinal() {
    if (this.ExamSCEditForm.valid) {
      this.spinner.show();
      this.umsService.submitSupExam(this.ExamSCEditForm.value).subscribe(
        (res) => {
          this.spinner.hide();
          this.loadExamRecords();
          if (res.status) {
            let data = {};
            data['message'] = res.message;
            data['title'] = 'Information';
            data['icon'] = 'fas fa-check';
            this.dialogRef =
              this.modalPopupService.openPopup<AlertBoxComponent>(
                AlertBoxComponent,
                data
              );
          }
        },
        (ERROR: HttpErrorResponse) => {
          this.spinner.hide();
          let data = {};
          data['message'] = ERROR.error.message;
          data['title'] = 'Information';
          data['icon'] = 'fas fa-close';
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
            AlertBoxComponent,
            data
          );
        }
      );
    } else {
      this.ExamSCEditForm.get('EcShId').markAsTouched();
      this.ExamSCEditForm.get('EcInCode').markAsTouched();
      this.ExamSCEditForm.get('EcOpId').markAsTouched();
    }
  }



  update() {
    this.updateDisable = true;
    if (this.ExamSCEditForm.value['EcInCode'] == 19) {
      this.StuFee = []
      let payload2 = {};
      payload2['CoCode'] = this.CoCode
      payload2['EmId'] = this.EmId
      payload2['SnNo'] = this.SessionNo
      let studentData = [];
      this.umsService.ExmFeeDetails(payload2).subscribe((res) => {
        let isPopupShown = false;
        // Initialize FeesNotPaid to false outside the subscription callback
        this.FeesNotPaid = false;
      
        if (res.status) {
          const studentData = res.data;
          const studentMap = new Map<string, any[]>();
      
          studentData.forEach(record => {
            const key = `${record.RgNo}_${record.StuNumber}`;
            const existingRecords = studentMap.get(key) || [];
            existingRecords.push(record);
            studentMap.set(key, existingRecords);
          });

      
          studentMap.forEach((records, key) => {
            const invalidRecord = records.find(record => record.TemplateCode != null);
            if (
              (!invalidRecord && records.some(record => record.FeeAmt == record.TotalPaidAmount || record.FeeAmt == null || record.TemplateCode == null)) ||
              (invalidRecord && records.some(record => record.FeeAmt != record.TotalPaidAmount && record.TemplateCode != null && (record.FeeStatus != 'N' && record.FeeStatus != 'Y')))
            ) {
              // Set FeesNotPaid to true only if there are unpaid fees
              this.FeesNotPaid = true;
              this.StuFee.push(records);
      
              // Show popup only if it's not already shown
              if (!isPopupShown) {
                const data = {
                  message: 'Exam Fees Payment Pending',
                  title: 'Alert',
                  icon: 'fa fa-question'
                };
                this.updateDisable = true;
                this.updateDisableMsg = true;
                this.UpdateError = data.message;
                this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
                isPopupShown = true;
              }
            }
          });
        } else {
          // Set FeesNotPaid to true and show a different popup if no fees are paid
          this.FeesNotPaid = true;
          const data = {
            message: 'Exam Fees Payment Not Paid Of Any Students',
            title: 'Alert',
            icon: 'fa fa-question'
          };
          this.updateDisable = true;
          this.updateDisableMsg = true;
          this.UpdateError = data.message;
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        }
      
        // Call updateFinal() only if FeesNotPaid remains false after processing all data
        if (!this.FeesNotPaid) {
          this.updateDisableMsg = false
          this.updateFinal();
        }
      });
    }
    else if (this.ExamSCEditForm.value['EcInCode'] == 20) {
      if (this.ShowExamTime == true) {
        let data = {};
        data['message'] = 'First Schedule Exam TimeTable';
        data['title'] = 'Alert';
        data['icon'] = 'fas fa-close';
        this.updateDisable = true;
        this.UpdateError = data['message']
        this.dialogRef =
          this.modalPopupService.openPopup<AlertBoxComponent>(
            AlertBoxComponent,
            data
          );
      }
      else if (this.ShowExamTime == false) {
        this.updateFinal()
      }

    }
    else if (this.ExamSCEditForm.value['EcInCode'] == 7) {
      this.spinner.show();
      let payload = {};
      payload['CoCode'] = this.CoCode
      payload['EmId'] = this.EmId
      payload['SnNo'] = this.SessionNo
      this.umsService.ExmFeeDetails(payload).subscribe((res) => {
        if(res.status){
          this.spinner.hide();
          let examfee = res.data;   
          let StatusN = examfee.filter(item => item.FeeStatus === 'N')
          if(StatusN.length > 0){
            this.spinner.hide();
            let data = {};
            data['message'] = 'Please Pay Paylater Fees';
            data['title'] = 'Alert';
            data['icon'] = 'fas fa-close';
            this.dialogRef =
            this.modalPopupService.openPopup<AlertBoxComponent>(
              AlertBoxComponent,
              data
            );
          }
          else if (StatusN.length === 0) {
            this.spinner.hide();
            this.updateFinal();
          }
        }
        else{
          this.spinner.hide();
          this.updateFinal();
        }
     })
    }
    else {
      this.updateFinal()
    }

  }

  updateFinal() {
    this.updateDisableMsg = false;
    this.spinner.show();
    let payload = {};
    payload['EcId'] = this.ExamSCEditForm.value['EcId'];
    payload['InCode'] = this.ExamSCEditForm.value['EcInCode'];
    this.umsService.ValidateSCHExamInput(payload).subscribe(
      (res) => {
        this.spinner.hide();
        if (res.message == '') {
          let data = {};
          data['message'] =
            'Database will be updated. Database Tags will be removed and the list will be marked Updated' +
            ', Proceed?';
          data['title'] = 'Process Result';
          data['icon'] = 'fa fa-question';
          this.dialogRef =
            this.modalPopupService.openPopup<ConformationModelComponent>(
              ConformationModelComponent,
              data
            );
          this.dialogRef.afterClosed().subscribe((result) => {
            if (result === 'yes') {
              this.updateDisable = true;
              this.updateInput(payload);
              this.ngOnInit();
              this.showDiv = false;
              return true;
            } else {
              this.updateDisable = false;
              let gstrVldtMesg = 'Processing Cancelled';
              let data = {};
              data['message'] = gstrVldtMesg;
              data['title'] = 'Information';
              data['icon'] = 'fas fa-close';
              this.dialogRef =
                this.modalPopupService.openPopup<AlertBoxComponent>(
                  AlertBoxComponent,
                  data
                );
              this.ngOnInit();
              this.showDiv = false;
              return false;
            }
          });
        } else {
          this.updateDisable = false;
          let gstrVldtMesg = res.message;
          let data = {};
          data['message'] = gstrVldtMesg;
          data['title'] = 'Information';
          data['icon'] = 'fas fa-check';
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
            AlertBoxComponent,
            data
          );
          return false;
        }
      },
      (ERROR: HttpErrorResponse) => {
        this.updateDisable = false
        this.spinner.hide();
        // alert(ERROR);
        this.ngOnInit();
        this.showDiv = false;
      }
    );
  }

  openGrid() {
    let data = {}
    const mergedArray = this.StuFee.reduce((accumulator, currentArray) => {
      return accumulator.concat(currentArray);
    }, []);
    data['data'] = mergedArray;
    const dialogRef = this.dialog.open(ExamFeeStudentsComponent, {
      width: '130vh',
      data,
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  updateInput(e) {
    this.spinner.show();
      let payload = {};
    (payload['LoginId'] = sessionStorage.getItem('userId')),
      (payload['EcId'] = e.EcId),
      (payload['InCode'] = e.InCode),
      (payload['Inst'] = this.umsService.secretdata['ClubPartTrans'])
    this.umsService.UpdateSCHExamInput(payload).subscribe(
      (res) => {
        this.spinner.hide();
        if (payload['InCode'] == 20) {
          this.centerAllocationApi(payload);
        } else {
          let gstrVldtMesg = res.message;
          let data = {};
          data['message'] = gstrVldtMesg;
          data['title'] = 'Information';
          data['icon'] = 'fas fa-check';
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
            AlertBoxComponent,
            data
          );
          this.loadExamRecords();
          this.ngOnInit();
          this.showDiv = false;
          return false;
        }
      },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        this.ngOnInit();
        this.showDiv = false;
        // alert(ERROR);
      }
    );
  }

  centerAllocationApi(e) {
    this.spinner.show();
    let payload = {};
    (payload['LoginId'] = sessionStorage.getItem('userId')),
      (payload['EcId'] = e.EcId),
      (payload['RollNo'] = ''),
      (payload['Inst'] = this.umsService.secretdata['ClubPartTrans']);
    this.umsService.UpdateSCHExamCenterAllocationInput(payload).subscribe(
      (res) => {
        this.spinner.hide();
        let gstrVldtMesg = res.message;
        this.loadExamRecords();
        let data = {};
        data['message'] = gstrVldtMesg;
        data['title'] = 'Information';
        data['icon'] = 'fas fa-check';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
          AlertBoxComponent,
          data
        );
        this.ngOnInit();
        this.showDiv = false;
        return false;
      },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        this.ngOnInit();
        this.showDiv = false;
        // alert(ERROR);
      }
    );
  }

  DeletetheRecord() {
    const data = {};
    data['message'] = 'Are You Sure You Want To Delete This List ?';
    data['title'] = 'Alert';
    data['icon'] = 'fa fa-question';
    this.dialogRef = this.modalPopupService.openPopup<ConformationModelComponent>(ConformationModelComponent, data);
    this.dialogRef.afterClosed().subscribe(result => {
      if (result === 'yes') {
        this.Delete();
      } else {
        // this.ngOnInit();
      }
    });
  }

  Delete() {
    this.spinner.show();
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }), body: {
        EcShId: this.ExamSCEditForm.value['EcShId'],
        EcDesc: this.ExamSCEditForm.value['EcDesc'],
        EcInCode: this.ExamSCEditForm.value['EcInCode'],
        EcOpId: this.ExamSCEditForm.value['EcOpId'],
        EcOpenOpId: this.ExamSCEditForm.value['EcOpenOpId'],
        EcStatus: this.ExamSCEditForm.value['EcStatus'],
        FrontEcInCode: this.ExamSCEditForm.value['FrontEcInCode'],
        FrontList: this.ExamSCEditForm.value['FrontList'],
        EcListNo: this.ExamSCEditForm.value['EcListNo'],
        EcId: this.ExamSCEditForm.value['EcId']
      },
    };

    this.httpClient.delete(this.APIService + '/supervisor/examControl', options)
      .subscribe((s) => {
        this.spinner.hide();
        let cc = [];
        cc.push(s);
        let data = {}
        data['message'] = cc[0].message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe(result => {
          this.ngOnInit();
          this.showDiv = false;
        });
      }, (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        let data = {}
        data['message'] = ERROR.error.message
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.ngOnInit();
        this.showDiv = false;
      });
  }

  fetchSupExamRecord(SnNo) {
    this.spinner.show();
    let payload = {};
    payload['LoginId'] = sessionStorage.getItem('userId');
    payload['ShSnNo'] = SnNo;
    this.umsService.getSupExamRecord(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        this.ExamAList = res.data;
        this.filteredExamAList = this.ExamAList.slice();
      } else {
        this.ExamAList = [];
        this.filteredExamAList = this.ExamAList.slice();
      }
    },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        this.ExamAList = [];
        this.filteredExamAList = this.ExamAList.slice();
      }
    );
  }

  fetchSupExamInputs(ExamSrNo) {
    this.spinner.show();
    let payload = {};
    this.umsService.getSupExamInputs(payload).subscribe(
      (res) => {
        this.spinner.hide();
        if (res.status) {
          if (ExamSrNo == 1) {
            this.ExamInputList = res.data.filter(item => item.InCode !== 64);
            this.filteredExamInputList = this.ExamInputList.slice();
          } else {
            this.ExamInputList = res.data;
            this.filteredExamInputList = this.ExamInputList.slice();
          }
        } else {
          this.ExamAList = [];
        }
      },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        this.ExamAList = [];
        this.filteredExamInputList = this.ExamInputList.slice();
      }
    );
  }

  getOpratorsList() {
    this.spinner.show();
    let payload = {};
    this.umsService.getUserList(payload).subscribe(
      (res) => {
        this.spinner.hide();
        if (res.status) {
          this.userList = res.data;
          this.filtereduserList = this.userList.slice();
        } else {
          this.userList = [];
          this.filtereduserList = this.userList.slice();
        }
      },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        this.ExamAList = [];
        this.filtereduserList = this.userList.slice();
      }
    );
  }

  loadExamRecords() {
    this.spinner.show();
    this.FeesNotPaid = false;
    this.updateDisable = false;
    this.SaveDisable = false;
    this.Glob_EcShId = this.ExamSCEditForm.value['EcShId'];
    let payload = {};
    payload['EcShId'] = this.ExamSCEditForm.value['EcShId'];
    payload['EcInCode'] = this.ExamSCEditForm.value['FrontEcInCode'];
    payload['EcOpId'] = sessionStorage.getItem('userId');
    this.umsService.getSupExamEditRecord(payload).subscribe(
      (res) => {
        this.spinner.hide();
        if (res.status) {
          this.Table = true
          this.updateDisable = false;
          this.examRecords = res.data;
        } else {
          this.Table = false;
          this.updateDisable = false;
          this.examRecords = [];
        }
      },
      (ERROR: HttpErrorResponse) => {
        this.Table = false;
        this.updateDisable = false;
        this.spinner.hide();
        this.examRecords = [];
      }
    );

  }

  prepopulate(exam) {
    this.submitButton = false;
    this.updatereadonly = true;
    this.showDiv = true;
    let abc = exam.InDesc;
    if (exam.EcStatus == 'O') {
      this.updateButton = true;
    } else {
      this.updateButton = false;
    }
    if(exam.EcInCode == 64){
      this.EditListShow = false;
    }
    else{
      this.EditListShow = true;
    }
    this.inputname = exam.EcInCode
    this.ExamSCEditForm = this.fb.group({
      EcShId: new FormControl(this.Glob_EcShId),
      EcDesc: new FormControl(exam.EcDesc),
      EcInCode: new FormControl(exam.EcInCode),
      EcOpId: new FormControl(exam.LoginIdL1),
      EcOpenOpId: new FormControl(sessionStorage.getItem('userId')),
      EcStatus: new FormControl(exam.EcStatus),
      FrontEcInCode: new FormControl(''),
      FrontList: new FormControl(''),
      EcListNo: new FormControl(exam.EcListNo),
      EcId: new FormControl(exam.EcId),
    });
  }

  addNew() {
    let tempEcShId = this.ExamSCEditForm.value['EcShId'];
    let temp = this.ExamSCEditForm.value['FrontEcInCode'];
    if (this.ExamSCEditForm.controls['EcShId'].valid) {
      this.submitButton = true;
      this.showDiv = true;
      this.updateButton = false;
      this.updatereadonly = false;
      this.ExamSCEditForm.reset();
      this.ExamSCEditForm.controls['FrontEcInCode'].setValue(temp);
      this.ExamSCEditForm.controls['EcShId'].setValue(tempEcShId);
      this.ExamSCEditForm.controls['EcDesc'].setValue('New');
      this.ExamSCEditForm.controls['EcOpId'].setValue(parseInt(this.loginId));
      this.ExamSCEditForm.controls['EcOpenOpId'].setValue(parseInt(this.loginId));
      this.ExamSCEditForm.controls['EcStatus'].setValue('O');
    } else {
      this.ExamSCEditForm.get('EcShId').markAsTouched();
    }
  }

  reset(exm, emid) {
    this.EmId = emid
    this.ExamSCEditForm.reset();
    this.showDiv = false;
    this.SHID = exm
    this.CheckExamTimeTable(exm)
    this.CheckRollNo(exm)
    this.ExamSCEditForm.controls['EcShId'].setValue(exm);
    this.ExamSCEditForm.controls['EcDesc'].setValue('New');
    this.ExamSCEditForm.controls['EcOpId'].setValue(parseInt(this.loginId));
    this.ExamSCEditForm.controls['EcOpenOpId'].setValue(parseInt(this.loginId));
    this.ExamSCEditForm.controls['EcStatus'].setValue('O');
    this.getExamData(emid)
  }

  getExamData(emid) {
    let payload = {}
    payload['EmId'] = emid;
    this.umsService.getExam(payload).subscribe((res) => {
      this.CoCode = res.data[0]['EmCoCode']
      this.ExamSrNo = res.data[0]['EmSrNo']

      this.fetchSupExamInputs(this.ExamSrNo);
      // if (this.ExamSrNo == 1) {
      //   let data = this.filteredExamInputList;
      //   const dataOFfliter = data.filter(item => item.InCode !== 64);
      //   this.filteredExamInputList = dataOFfliter;
      // }
    })
  }

  printAll() {
    if (this.ExamSCEditForm.controls['EcShId'].valid) {
      let data = {};
      data['message'] = 'Select from dropdown';
      data['title'] = 'Information';
      data['icon'] = 'fas fa-box-open';
      this.dialogRef = this.dialog.open(PrintMsgBoxComponent, {
        disableClose: true,
        data,
      });
      this.dialogRef.afterClosed().subscribe(result => {
        this.PrintAll(result)

      });
    } else {
      this.ExamSCEditForm.get('EcShId').markAsTouched();
    }
  }

  PrintAll(data) {
    this.submitpayload = this.ExamSCEditForm.value;
    let payload1 = {}
    payload1['EcId'] = this.ExamSCEditForm.value['EcId'],
      payload1['ShId'] = this.ExamSCEditForm.value['CEcShId'],
      payload1['MenuName'] = 'Exam Edit ControlAll';
    payload1['InCode'] = 0;
    payload1['Title'] = '';
    payload1['SubTitle'] = 0;
    payload1['AllLast'] = data
    let jsonString = JSON.stringify(payload1);
    var filter: any;
    filter = {
      "LoginId": parseInt(sessionStorage.getItem('userId')) ? parseInt(sessionStorage.getItem('userId')) : 0,
      "RptCode": 103,
      "InstName": '',
      "InstNo": this.umsService.secretdata['ClubPartTrans'] ? this.umsService.secretdata['ClubPartTrans'] : 0,
      "ShId": this.ExamSCEditForm.value['EcShId'],
      "CgCode": '',
      "RollNo": '',
      "Cent": '',
      "TnCode": '',
      "EsId": '',//this.emid
      "CsNo": '',
      "PgBreak": '',
      "StrId": '', //this.submitpayload['strId'] ? this.submitpayload['strId'] : 0,
      "StrCode": '',
      "RgNo": '',
      "UC": '',
      "Ledger": '',
      "RegnRoll": '',
      "DsCode": '',
      "CoCode": '', //this.submitpayload['course'] ? this.submitpayload['course'] : 0,
      "SnNo": this.SessionNo,
      "Extra1": jsonString,
    }
    var payload: any;
    payload = filter;
    this.umsService.setData(JSON.stringify(payload));
    this.redirect('reports')
  }

  print() {
    this.submitpayload = this.ExamSCEditForm.value;
    let payload1 = {}
    payload1['EcId'] = this.ExamSCEditForm.value['EcId'],
      payload1['MenuName'] = 'Exam Edit Control';
    payload1['InCode'] = this.ExamSCEditForm.value['EcInCode'];
    payload1['Title'] = '';
    payload1['SubTitle'] = this.ExamSCEditForm.value['EcInCode'];
    let jsonString = JSON.stringify(payload1).replace(/\\/g, '');
    var filter: any;
    filter = {
      "LoginId": parseInt(sessionStorage.getItem('userId')) ? parseInt(sessionStorage.getItem('userId')) : 0,
      "RptCode": 132,
      "InstName": '',
      "InstNo": this.umsService.secretdata['ClubPartTrans'] ? this.umsService.secretdata['ClubPartTrans'] : 0,
      "ShId": this.ExamSCEditForm.value['EcShId'],
      "CgCode": '',
      "RollNo": '',
      "Cent": '',
      "TnCode": '',
      "EsId": '',//this.emid
      "CsNo": '',
      "PgBreak": '',
      "StrId": '', //this.submitpayload['strId'] ? this.submitpayload['strId'] : 0,
      "StrCode": '',
      "RgNo": '',
      "UC": '',
      "Ledger": '',
      "RegnRoll": '',
      "DsCode": '',
      "CoCode": '', //this.submitpayload['course'] ? this.submitpayload['course'] : 0,
      "SnNo": this.SessionNo,
      "Extra1": JSON.stringify(payload1),
    }
    var payload: any;
    payload = filter;
    this.umsService.setData(JSON.stringify(payload));
    this.redirect('reports')
  }

  redirect(to): void {
    this.router.navigate([to]);
  }

  selected(data) {
    this.selectedRow = data;
    sessionStorage.setItem('selectedRow', this.selectedRow)
    this.incode = data.EcInCode
  }

  CheckExamTimeTable(ShId) {
    this.ShowExamTime = false
    let payload = {}
    payload['ShId'] = ShId
    this.umsService.CheckExamTimeTable(payload).subscribe((res) => {
      if (res.data.length == 0) {
        this.ShowExamTime = true
      }
      else if (res.data.length > 0) {
        this.ShowExamTime = false
      }
    })
  }

  CheckRollNo(ShId) {
    this.ShowRollNo = false
    let payload = {}
    payload['ShId'] = ShId
    this.umsService.CheckRollNo(payload).subscribe((res) => {
      if (res.data.length == 0) {
        this.ShowRollNo = true
      }
      else if (res.data.length > 0) {
        this.ShowRollNo = false
      }
    })
  }

  InputFor(data) {
    this.incode = data
  }



  checkCenterAllocationForMarkEntry() {
    this.spinner.show();
    let payload = {};
    payload['EcShId'] = this.ExamSCEditForm.value['EcShId'];
    payload['EcInCode'] = '';
    payload['EcOpId'] = sessionStorage.getItem('userId');
    this.umsService.getSupExamEditRecord(payload).subscribe(
      (res) => {
        this.spinner.hide();
        if (res.status) {
          this.examRecords = res.data;
          let allStatusU = true;
          this.examRecords.forEach(element => {
            if (element.EcInCode === 7 && (element.EcStatus == "O" || element.EcStatus == "U")) {
              allStatusU = false;
          }
          });
          if (allStatusU) {
            this.submitFinal();
        } else {
            this.showAlert('Center Allocation Already Done');
        }

        } 
        
      },
      (ERROR: HttpErrorResponse) => {
        this.Table = false;
        this.spinner.hide();
        this.examRecords = [];
      }
    );


  }

}
